import React, { useEffect, useState } from "react";
import "./AddSchoolToCourseForm.css";
import TextFieldInput from "../../../Atoms/Inputs/TextField/TextFieldInput";
import PrimaryButton from "../../../Atoms/Buttons/Primary/PrimaryButton";
import MenuItem from "@mui/material/MenuItem";
import useEdit from "../../../../Hooks/useEdit";
import useSave from "../../../../Hooks/useSave";
import {
  classesURL,
  courseListURL,
  courseURL,
  schoolListURL,
  teacherListURL,
} from "../../../../Hooks/URL";
import { Formik } from "formik";
import * as Yup from "yup";
import useFetch from "../../../../Hooks/useFetch";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers";
import { useNavigate } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import { Autocomplete } from "@mui/material";

const AdminSchoolToCourseSchema = Yup.object().shape({
  schoolIds: Yup.array().required("Schools required !!"),
});

function AddSchoolToCourseForm({ Edit = false, course, url }) {
  const navigate = useNavigate();
  const [newObject, setNewObject] = useState({});
  const [goEdit, setGoEdit] = useState(false);
  const [goSave, setGoSave] = useState(false);
  const { state, loading: editLoading } = useEdit(
    url,
    goEdit,
    setGoEdit,
    newObject,
    false,
    false
  );
  const { saveState, loading: addLoading } = useSave({
    url: `${courseURL}/${course?.id}/schools`,
    goSave,
    setGoSave,
    newObject,
  });
  const { data: schoolsList } = useFetch(schoolListURL);

  useEffect(() => {
    if (state.dataRes.status == "success") {
      navigate(`/programs/${course?.id}`);
    }
  }, [state]);

  useEffect(() => {
    if (saveState.dataRes.status == "success") {
      navigate(`/programs/${course?.id}`);
    }
  }, [saveState]);

  return (
    <div className="CourseSmallFormWrapper">
      <Formik
        initialValues={{
          schoolIds: Edit ? course?.schoolIds ?? [] : [],
        }}
        validationSchema={AdminSchoolToCourseSchema}
        onSubmit={(values) => {
          if (Edit) {
            const prev = {
              schoolIds: course?.schoolIds ?? [],
            };
            const newObj = { schoolIds: values.schoolIds?.map((s) => s.id) };
            setNewObject(
              Object.fromEntries(
                Object.entries({
                  ...prev,
                  ...newObj,
                }).filter(([key]) => prev[key] != newObj[key])
              )
            );
            setGoEdit(true);
          } else {
            setNewObject({ schoolIds: values.schoolIds?.map((s) => s.id) });
            setGoSave(true);
          }
        }}
      >
        {({ values, errors, touched, handleSubmit, setValues }) => (
          <form autoComplete="off" onSubmit={handleSubmit}>
            <div className="ClassFormContainer">
              <div style={{ width: "100%" }}>
                <Autocomplete
                  multiple
                  options={schoolsList?.data ?? []}
                  getOptionLabel={(option) => option?.name}
                  filterSelectedOptions
                  name={"schoolIds"}
                  className="chooseStudents"
                  value={values.schoolIds}
                  onChange={(e, newValue) =>
                    setValues({ ...values, schoolIds: newValue })
                  }
                  renderInput={(params) => (
                    <TextFieldInput
                      {...params}
                      label="Add School"
                      placeholder="Schools"
                      className={`Input`}
                      styles={{ width: "100%" }}
                      name={"schoolIds"}
                      Required={false}
                    />
                  )}
                />
                {errors.schoolIds && touched.schoolIds && errors.schoolIds && (
                  <p className="error">
                    {errors.schoolIds && touched.schoolIds && errors.schoolIds}
                  </p>
                )}
              </div>
              {/* <div style={{ width: "100%" }}>
                <TextFieldInput
                  select
                  label="School"
                  newValue={values.schoolIds}
                  name={"schoolId"}
                  change={(e) => {
                    handleChange(e);
                    setSchoolID(e.target.value);
                  }}
                  blur={handleBlur}
                  fullWidth
                  className={`Input`}
                  variant="outlined"
                  SelectProps={{
                    displayEmpty: true,
                  }}
                >
                  <MenuItem value="" className="teacherSelect" disabled>
                    Choose School
                  </MenuItem>
                  {schoolsList?.data?.map((schoolItem) => (
                    <MenuItem value={schoolItem?.id}>
                      {schoolItem?.name}
                    </MenuItem>
                  ))}
                </TextFieldInput>
                {errors.schoolId && touched.schoolId && errors.schoolId && (
                  <p className="error">
                    {errors.schoolId && touched.schoolId && errors.schoolId}
                  </p>
                )}
              </div> */}
            </div>

            <div style={{ display: "flex", justifyContent: "center" }}>
              <button
                className="actionButton primary addButton"
                onClick={handleSubmit}
                disabled={Edit ? editLoading : addLoading}
              >
                {Edit ? (
                  editLoading ? (
                    <PulseLoader color="white" size={8} />
                  ) : (
                    "Edit"
                  )
                ) : addLoading ? (
                  <PulseLoader color="white" size={8} />
                ) : (
                  "Add"
                )}
              </button>
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
}

export default AddSchoolToCourseForm;
